export default __webpack_public_path__ + "static/media/line-with-dot.eb752c40.svg";